<template>
  <div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular indeterminate size="64" color="primary" />
    </v-overlay>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          reviewExerciseFormList: this.reviewExerciseFormList,
          errMsg: this.errMsg,
          isEdit: this.editMode,
          isWizard: this.wizardMode,
        }"
        v-on:input="formData = $event"
        v-on:cancel="cancelHandler"
        v-on:save="saveHandler"
        v-on:error="errorHandler"
      />
      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ReviewExerciseForm from "../../../components/performance/reviewexercise/Form";
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
  components: {
    "app-form": ReviewExerciseForm,
    "app-error": ErrorDialog,
  },

  data() {
    return {
      id: this.$route.params.id,
      pageTitle: this.$t('pmreviewexercise.editappraisalexercise'),
      pageTitleValue: "",

      formData: {
        id: this.$route.params.id,
        reviewcode: null,
        description: null,
        assessmentid: null,
        assessmentcode: null,
        startdate: null,
        enddate: null,
        formtype: null,
        pmrankmapsetid: null,
        pmrankmapsetcode: null,
        remarks: null,
        pmkpiexerciseid: null,
        pmkpiexercisecode: null,
        statusid: null,
        staffFirst: false,
        initiated: this.$route.params.item ? this.$route.params.item.initiated : null,
        ongoing: this.$route.params.item ? this.$route.params.item.ongoing : null,
        completed: this.$route.params.item ? this.$route.params.item.completed : null,
        stamp: 0,
        userid: this.$store.getters.userId,
      },

      rankMapSet: [],
      rankMapSetList: [],
      assessmentType: [],
      assessmentTypeList: [],
      kpiSettingExercise: [],
      kpiSettingExerciseList: [],

      reviewExerciseForm: [],
      reviewExerciseFormList: [],

      errMsg: "",
      isErr: false,
      editMode: true,
      wizardMode: false,
      loading: true,
    };
  },

  methods: {

    errorHandler($event) {
      this.isErr = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    async loadReviewExercise() {
      const vm = this;

      try {
        const res = await this.$store.dispatch('get', {url: "/reviewexercise/" + vm.id});
        // Merge the new data into the existing formData
        vm.formData = { ...vm.formData, ...res.data.rec[0] };
        // Format startdate if it exists
        if (vm.formData.startdate) {
          vm.formData.startdate = moment(vm.formData.startdate).format('YYYY-MM-DD');
        }
        // Format enddate if it exists
        if (vm.formData.enddate) {
          vm.formData.enddate = moment(vm.formData.enddate).format('YYYY-MM-DD');
        }
        //Rank Map Set
        if (vm.formData.pmrankmapsetid) {
          vm.formData.pmrankmapsetcode = vm.rankMapSetList.find((item) => item.value === vm.formData.pmrankmapsetid).text;
        }
        //Assessment Type
        if (vm.formData.assessmentid) {
          vm.formData.assessmentcode = vm.assessmentTypeList.find((item) => item.value === vm.formData.assessmentid).text;
        }
        //KPI Exercise
        if (vm.formData.pmkpiexerciseid) {
          vm.formData.pmkpiexercisecode = vm.kpiSettingExerciseList.find((item) => item.value === vm.formData.pmkpiexerciseid).text;
        }
        vm.pageTitleValue = res.data.rec[0].reviewcode;
        vm.formData.stamp = 0;
      } catch (err) {
        vm.isErr = !vm.isErr;
        vm.errMsg = err;
      }
    },

    loadRankMapSet() {
        const vm = this;
        return this.$store.dispatch('get', {url: "/rankmapset/active/all"})
        .then(function (res) {
            vm.rankMapSet = res.data.rec;
    
            for (let i = 0; i < vm.rankMapSet.length; i++) {
                vm.rankMapSetList.push({
                text: vm.rankMapSet[i].rankmapset,
                value: vm.rankMapSet[i].id,
                });
            }
            })
        .catch(function (err) {
            vm.errMsg = err;
        });
    },

      loadAssessmentType() {
        const vm = this;

        return this.$store.dispatch('get', {url: "/assessment/all"})
        .then(function (res) {
          vm.assessmentType = res.data.rec;
          for (let i = 0; i < vm.assessmentType.length; i++) {
              vm.assessmentTypeList.push({
              text: vm.assessmentType[i].assessmentcode,
              value: vm.assessmentType[i].id,
              });
          }
        })
        .catch(function (err) {
            vm.errMsg = err;
        });
      },

      loadKPISettingExercise() {
        const vm = this;
        return this.$store.dispatch('get', {url: "/kpiexercise/all/"})
        .then(function (res) {
            vm.kpiSettingExercise = res.data.rec;
    
            for (let i = 0; i < vm.kpiSettingExercise.length; i++) {
                vm.kpiSettingExerciseList.push({
                text: vm.kpiSettingExercise[i].kpiexercode,
                value: vm.kpiSettingExercise[i].id,
                });
            }
            })
        .catch(function (err) {
            vm.errMsg = err;
        });
      },

      loadReviewExerciseForm() {
        const vm = this;
        return this.$store.dispatch('get', {url: "/reviewexerciseform/" + vm.$route.params.id})
        .then(function (res) {
            vm.reviewExerciseFormList = res.data.rec;
            })
        .catch(function (err) {
            vm.errMsg = err;
        });
      },

      saveHandler() {
        const vm = this;

        if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
            return false;
        }

        this.formData.userid = vm.$store.getters.userId;

        this.$store.dispatch('put', {url: "/reviewexercise/" + vm.id, payload: vm.formData})
        .then((res) => {
            if (res.data.error) {
              vm.isErr = !vm.isErr;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: "reviewexerciselist" });
            }
        })
        .catch((err) => {
            vm.isErr = !vm.isErr;
            vm.errMsg = err;
        });
      },
  },

  async mounted() {
    Promise.all([
      await this.loadKPISettingExercise(), 
      await this.loadRankMapSet(), 
      await this.loadAssessmentType(), 
      await this.loadReviewExerciseForm()])
        .then(() => {
            // After loading dependencies, get Review Exercise
            return this.loadReviewExercise();
        })
        .then(() => {
            // Once everything is loaded, set loading to false
            this.loading = false;
        })
        .catch((err) => {
            // Handle any errors that occur during the process
            this.isErr = true;
            this.errMsg = err;
            console.error("Error:", err);
        });
  },
};
</script>